import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { fadeUp } from '../../utils/motion';
export function SkpLlmTeaser() {
  return <section className="bg-white py-16 lg:py-20 border-y border-line" data-id="element-1959" data-mp="19fxxpu7cavob">
      <motion.div {...fadeUp} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 items-center" data-id="element-1960" data-mp="19g6cjrn0wb25">
        <div className="lg:col-span-5" data-id="element-1961" data-mp="223jzcwx0bq8j">
          <p className="text-sm font-medium text-teal mb-3" data-id="element-1962" data-mp="226oake8w3m8p">LLM vs. SKP</p>
          <h2 className="font-heading font-bold text-3xl lg:text-4xl text-ink-dark tracking-tight leading-tight" data-id="element-1963" data-mp="1x60n22jvdnj8">
            Why not just use an LLM?
          </h2>
        </div>
        <div className="lg:col-span-7" data-id="element-1964" data-mp="1nenut9u5svco">
          <p className="text-lg text-ink-muted leading-relaxed mb-6" data-id="element-1965" data-mp="1ndmjr5d588uy">
            Think of the LLM as a capable research assistant. Think of SKP as
            the organization’s working knowledge system: its sources,
            definitions, connected ideas, review decisions, and history.
          </p>
          <a href="/llm-vs-skp" className="inline-flex items-center gap-2 text-navy font-semibold hover:text-navy-light transition-colors duration-150 whitespace-nowrap" data-id="element-1966" data-mp="20367zstf2xn6">
            See how they differ and work together
            <ArrowRight size={16} data-id="element-1967" data-mp="1v9bkeeaoxyit" />
          </a>
        </div>
      </motion.div>
    </section>;
}